module.exports = __webpack_public_path__ + "images/wxwork/img-wcwf-2@3x-a790998cce2e30c931876868efa3368d.png";